<svelte:head>

    <link rel="stylesheet" type="text/css" href="/global.css" />
    <link rel="stylesheet" type="text/css" href="/css/forms.css" />

</svelte:head>

<script>

    import { onMount } from "svelte";
    import { getContext } from "svelte";
    import { fade } from 'svelte/transition';

    import SettingsNav from "./settingsnav.svelte";

    import {
        errorReasons,
        userProfile,
        userProfileSave,
        userPasswordChange
    } from "../api.svelte";

    import {
        checkUnauthorized
    } from "../../utils/session";


    const router = getContext('router');

    const ERROR_DISAPPEAR_AFTER = 5500;
    const SUCCESS_DISAPPEAR_AFTER = 3500;


    let profile;

    let pass = {
        'old': '',
        'new': ''
    };

    let profileFormError = false;
    let passwordFormError = false;

    let profileIsLoading = false;
    let passwordIsLoading = false;

    let profileIsSuccessful = false;
    let passwordIsSuccessful = false;

    let errorResetTimer = null;
    let successResetTimer = null;

    $: getProfileButtonText = () => {

        return (profileIsSuccessful) ? 'Gespeichert' : 'Speichern';
    };

    $: getPasswordButtonText = () => {

        return (passwordIsSuccessful) ? 'Gespeichert' : 'Speichern';
    };


    onMount(() => {

        getUserProfile();

    });

    let getUserProfile = () => {

        userProfile().then((profileResult) => {

            if (profileResult['status'] !== 'success') {

                if (checkUnauthorized(router, profileResult)) {

                    return;
                }

                console.log(profileResult);

                return;

            }

            profile = profileResult['profile'];

        });

    };

    let startErrorResetTimer = () => {

        if (errorResetTimer) {

            clearTimeout(errorResetTimer);
        }

        errorResetTimer = setTimeout(() => {

            profileFormError = false;
            passwordFormError = false;

        }, ERROR_DISAPPEAR_AFTER);

    };

    let startSuccessResetTimer = () => {

        if (successResetTimer) {

            clearTimeout(successResetTimer);
        }

        successResetTimer = setTimeout(() => {

            profileIsSuccessful = false;
            passwordIsSuccessful = false;

        }, SUCCESS_DISAPPEAR_AFTER);

    };

    let saveProfileHandler = () => {

        if (profileIsLoading) return;

        if (profile['name'] === '' || profile['company'] === '') {

            profileFormError = 'fill_fields';
            startErrorResetTimer();

            return;

        }

        profileIsLoading = true;

        let updatedProfile = {
            'name': profile['name'],
            'company': profile['company']
        };

        userProfileSave(updatedProfile).then((saveResult) => {

            profileIsLoading = false;

            if (saveResult['status'] !== 'success') {

                profileFormError = saveResult['reason'];
                startErrorResetTimer();

                return;

            }

            getUserProfile();

        });

    };

    let savePasswordHandler = () => {

        if (passwordIsLoading) return;

        if (pass['old'] === '' || pass['new'] === '') {

            passwordFormError = 'fill_fields';
            startErrorResetTimer();

            return;

        }

        passwordIsLoading = true;

        userPasswordChange(pass['old'], pass['new']).then((changeResult) => {

            passwordIsLoading = false;

            if (changeResult['status'] !== 'success') {

                passwordFormError = changeResult['reason'];
                startErrorResetTimer();

                return;

            }

            pass = {
                'old': '',
                'new': ''
            };

        });

    };

</script>


<div class="settings-wrapper">

    <SettingsNav
            active="profile"
            showBack={false}
            showDelete={false} />

    <h2>Profil bearbeiten</h2>

    <div id="profile-manage">

        {#if profile}

            <div class="forms-container forms" in:fade>

                <form
                        on:submit|preventDefault={() => saveProfileHandler()}
                        id="profileform"
                        class="forms {(profileIsSuccessful ? 'success' : '')}">

                    {#if profileFormError}

                        <div transition:fade id="error">

                            {errorReasons[profileFormError]}

                        </div>

                    {/if}

                    <div class="input-title">E-Mail</div>

                    <input
                            bind:value={profile['email']}
                            disabled
                            name="email"
                            type="email"
                            placeholder="E-Mail" />

                    <div class="input-title">Name</div>

                    <input
                            bind:value={profile['name']}
                            name="fullame"
                            type="text"
                            placeholder="Name" />

                    <div class="input-title">Firma</div>

                    <input
                            bind:value={profile['company']}
                            name="company"
                            type="text"
                            placeholder="Firma" />

                    <button
                            class={(profileIsLoading) ? 'loading btn' : 'btn'}>

                        <span>Speichern</span>
                        <img src="/images/button-loader.svg" />

                    </button>

                </form>

            </div>

            <div id="password-container" class="forms-container forms" in:fade>

                <form
                        on:submit|preventDefault={() => savePasswordHandler()}
                        id="passwordform"
                        class="forms {(passwordIsSuccessful ? 'success' : '')}">

                    {#if passwordFormError}

                        <div transition:fade class="error">

                            {errorReasons[passwordFormError]}

                        </div>

                    {/if}

                    <div class="section-title">Passwort ändern</div>

                    <div class="input-title">Aktuelles Passwort</div>

                    <input
                            bind:value={pass['old']}
                            name="oldpass"
                            type="password"
                            placeholder="Aktuelles Passwort" />

                    <div class="input-title">Neues Passwort</div>

                    <input
                            bind:value={pass['new']}
                            name="newpass"
                            type="password"
                            placeholder="Neues Passwort" />

                    <button
                            class={(passwordIsLoading) ? 'loading btn' : 'btn'}>

                        <span>Speichern</span>
                        <img src="/images/button-loader.svg" />

                    </button>

                </form>

            </div>

        {/if}

    </div>

</div>


<style>

    #profile-manage {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 80vh;
    }

    #profileform input,
    #profileform button,
    #passwordform input,
    #passwordform button,
    #profileform :global(.forms-dropdown button),
    #profileform :global(.forms-dropdown .bx--list-box__menu) {
        width: 28.6vh;
        padding: 1.42vh;
        margin-bottom: 2.5vh;
        font-size: 1.78vh;
    }

    #profileform button,
    #passwordform button {
        width: 31.46vh;
        margin-bottom: 0;
    }

    .input-title {
        margin-bottom: 0.92vh;
        font-family: 'Raleway', sans-serif;
        font-size: 1.48vh;
        font-weight: 400;
        text-align: left;
    }

    #password-container {
        margin-left: 7.22vh;
    }

    .section-title {
        margin-bottom: 3.14vh;
        font-family: 'Raleway', sans-serif;
        font-weight: 400;
        font-size: 1.85vh;
        text-transform: uppercase;
        text-align: left;
    }

    #error, .error {
        padding-top: 1vh;
        padding-bottom: 1vh;
        margin-bottom: 1.5vh;
    }

</style>
